import * as React from 'react';
import { GroupedComboBoxDropDownBase } from './GroupedComboBoxDropDown.base';
import { styled } from '@fluentui/react';
import { getStyles } from './GroupedComboBoxDropDown.styles';
import {
    IGroupedComboBoxDropDownProps,
    IGroupedComboBoxDropDownStyleProps,
    IGroupedComboBoxDropDownStyles,
} from './GroupedComboBoxDropDown.types';

/**
 * The GroupedComboBoxDropDown control renders the dropdown part of the {@link GroupedComboBox} control.
 */
export const GroupedComboBoxDropDown: React.FunctionComponent<IGroupedComboBoxDropDownProps> =
    styled<
        IGroupedComboBoxDropDownProps,
        IGroupedComboBoxDropDownStyleProps,
        IGroupedComboBoxDropDownStyles
    >(GroupedComboBoxDropDownBase, getStyles, undefined, {
        scope: 'GroupedComboBoxDropDown',
    });

GroupedComboBoxDropDown.displayName = 'GroupedComboBoxDropDown';
